<wuc-button type="clean" modal-close-btn title="Sluit">
    <wuc-icon-ui icon="cross-closed"></wuc-icon-ui>
</wuc-button>
<h2 modal-title>Verzekering annuleren</h2>
<div modal-content>
    <p>Weet u zeker dat u deze verzekering wilt annuleren?</p>
    <p *ngIf="errors?.length">
        <wuc-card cardStyle="tertiary" padding="medium">
            <wuc-list icon="cross">
                <wuc-list-item *ngFor="let error of errors">{{ error.message }}</wuc-list-item>
            </wuc-list>
        </wuc-card>
    </p>
</div>

<div modal-actions alignment="between">
    <wuc-link type="secondary" (clicked)="close()">Nee, toch niet</wuc-link>
    <wuc-button type="primary" (buttonClick)="cancelAddedProduct()" [disabled]="isDisabled">
        Ja, verzekering annuleren
    </wuc-button>
</div>
